module.exports = "/packs/shares-4930461-268500d3937912aa69821922b31fefb9.png";